import h, { createContext } from 'preact'
import { Field } from 'scripts/type'

export type FieldContextState = {
  fields: Field[]
  isLastPage: boolean
  isMultipleFields: boolean
  windowSizeSm: null | boolean
  windowSizeMd: null | boolean
  errFieldCodes: string[]
  setErrFieldCodes: (codes: FieldContextState['errFieldCodes']) => void
  refreshWidgetHeight?: () => void
  syncFieldLabelLength?: number
  isDynamicLastPage?: boolean
}

const FieldsContext = createContext<FieldContextState | undefined>(undefined)
export default FieldsContext
